export const BILLING_FETCH_STRIPE_CONFIG_REQUEST =
  'BILLING_FETCH_STRIPE_CONFIG_REQUEST';
export const BILLING_FETCH_STRIPE_CONFIG = 'BILLING_FETCH_STRIPE_CONFIG';

export const BILLING_CREATE_PORTAL_REQUEST = 'BILLING_CREATE_PORTAL_REQUEST';
export const BILLING_CREATE_PORTAL = 'BILLING_CREATE_PORTAL';
